/**
 * Enumeration of download delimited types.
 */
export enum DownloadFormat {
    COMMA = ',',
    PIPE = '|',
    TAB = '\t'
}


// WEBPACK FOOTER //
// ./src/models/interfaces/download-format.ts